import router from '@/router/index'
import useStore from '@/store/main'
import { localStorage } from '@/utils/storage'
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'
import JSONBIG from 'json-bigint'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

// 设置接口超时时间
// axios.defaults.timeout = 30000
// 请求地址，这里是动态赋值的的环境变量
// @ts-ignore
// axios.defaults.baseURL = import.meta.env.VITE_APP_BASE_API
const http = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API as string,
  transformResponse: (response) => {
    const json = JSONBIG({
      storeAsString: true,
    })
    return json.parse(response)
  },
})

// NProgress Configuration
NProgress.configure({
  showSpinner: false,
})
// 解决js number精度问题
// axios.defaults.transformResponse = (response) => {
//   const json = JSONBIG({
//     storeAsString: true,
//   })
//   return json.parse(response)
// }

//HTTPrequest拦截
http.interceptors.request.use(
  (config): AxiosRequestConfig<any> => {
    NProgress.start() // start progress bar
    // 配置请求头
    config.headers = Object.assign({}, config.headers, {
      'Content-Type': 'application/json;charset=UTF-8',
      loginType: 'adminPublic',
      os: 'admin',
    })
    const { user } = useStore()
    if (user.token) {
      config.headers.token = `${localStorage.get('token')}`
      config.headers.uid = `${localStorage.get('userInfo').id}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

//http response 拦截器
http.interceptors.response.use(
  (res: AxiosResponse) => {
    NProgress.done()
    const defineStatus = Number(res.data.error) || 10000
    const message = res.data.message || '未知错误'
    // 如果请求为非10000否者默认统一处理
    if (defineStatus !== 10000) {
      ElMessage.error(message)
      return Promise.reject(message)
    }
    return res.data
  },
  (error) => {
    NProgress.done()
    const { response } = error
    if (response) {
      const status = Number(response.status) || 200
      let message = response.data.message || '未知错误'
      const { user } = useStore()
      if (status === 401) {
        message = '登录失效，请重新登录！'
        localStorage.clear() // 清除浏览器全部缓存
        user.$reset()
        router.push({
          path: '/login',
        })
      } else if (status === 404) {
        router.push({
          path: '/ErrorPage/404',
        })
      }
      ElMessage.error(message)
      return Promise.reject(response.data)
    }
    ElMessage.error('请稍后再试')
  }
)

export default http
